import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useToast } from '../contexts/ToastContext';

const Toast = () => {
  const { toasts, dismissToast } = useToast();

  const getToastStyles = (type) => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-green-500 dark:bg-green-600',
          icon: '✅',
          text: 'text-white'
        };
      case 'error':
        return {
          bg: 'bg-red-500 dark:bg-red-600',
          icon: '❌',
          text: 'text-white'
        };
      case 'warning':
        return {
          bg: 'bg-orange-500 dark:bg-orange-600',
          icon: '⚠️',
          text: 'text-white'
        };
      case 'info':
      default:
        return {
          bg: 'bg-blue-500 dark:bg-blue-600',
          icon: 'ℹ️',
          text: 'text-white'
        };
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none" aria-live="polite" aria-atomic="true">
      <AnimatePresence>
        {toasts.map((toast) => {
          const styles = getToastStyles(toast.type);

          return (
            <motion.div
              key={toast.id}
              initial={{ opacity: 0, y: 20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, x: 100, scale: 0.95 }}
              transition={{ duration: 0.2 }}
              className={`${styles.bg} ${styles.text} rounded-lg shadow-lg px-4 py-3 max-w-sm pointer-events-auto`}
            >
              <div className="flex items-start gap-3">
                <span className="text-lg flex-shrink-0">{styles.icon}</span>

                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium break-words">{toast.message}</p>

                  {toast.action && (
                    <button
                      onClick={() => {
                        toast.action.onClick();
                        dismissToast(toast.id);
                      }}
                      className="mt-2 text-xs font-semibold underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-transparent rounded"
                    >
                      {toast.action.label}
                    </button>
                  )}
                </div>

                <button
                  onClick={() => dismissToast(toast.id)}
                  className="flex-shrink-0 ml-2 text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white rounded"
                  aria-label="Dismiss"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default Toast;
